import React from 'react';
import {List, Typography} from '@mui/material';
import AccessListItem from './AccessListItem';

// eslint-disable-next-line no-unused-vars
export default function AccessList({
                                       accessMap = {},
                                       usersById = {},
                                       currentUserId,
                                       accessLoading,
                                       onChangeRole,
                                       onRemoveAccess
                                   }) {
    const entries = Object.entries(accessMap || {});

    if (accessLoading) {
        return (
            <Typography variant="body2" color="text.secondary">Loading access...</Typography>
        );
    }

    if (!entries.length) {
        return (
            <Typography variant="body2" color="text.secondary">No collaborators yet.</Typography>
        );
    }

    return (
        <List dense>
            {entries.map(([uid, role]) => (
                <AccessListItem
                    key={uid}
                    uid={uid}
                    user={usersById[uid]}
                    role={role}
                    isOwner={(role || '').toLowerCase() === 'owner'}
                    isCurrentUser={uid === currentUserId}
                    onChangeRole={onChangeRole}
                    onRemoveAccess={onRemoveAccess}
                />
            ))}
        </List>
    );
}
